module.exports = __webpack_public_path__ + "static/assets/274866440da7a3defef013bf6e3a8b94.svg";